module.exports = __webpack_public_path__ + "static/media/GoodGlueWebsite.f94c71c1.png";